import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./chat').then((c) => c.Chat),
    children: [
      {
        path: 'new',
        loadComponent: () =>
          import('./new-chat-component/new-chat-component').then(
            (c) => c.NewChatComponent,
          ),
      },
      {
        path: ':chatId',
        loadComponent: () =>
          import('./chat-conversation/chat-conversation').then(
            (c) => c.ChatConversation,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChatRoutingModule {}
